import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-travel-hospitality",
  templateUrl: "./travel-hospitality.component.html",
  styleUrls: ["./travel-hospitality.component.scss"],
})
export class TravelHospitalityComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
